import React from 'react';
import styled from 'styled-components';
import {CONSTS} from './_constants';
import { Image, PreviewApi } from "hooshyr-react-image";
import Link from './link';
import { FormImage } from '.';
import { flatMediaArray } from './dynamicForm';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
export enum FormViewItemEnum {
    Text= "text",
    TextArea= "textarea",
    CheckBox= "checkbox",
    Email= "email",
    Url= "url",
    Image= "image",
    Number="number",
    Editor="editor",
    Select="select",
    Radio="radio"
}
type FormViewItemProps = {
    className?: string,
    type:       FormViewItemEnum,
    label?:      string,
    value:      any
}
const FormViewItemComponent = (props: FormViewItemProps) => {
    const getCmp = () => {
        
        if(props.value == "") return "-"
        switch (props.type) {
            
            case FormViewItemEnum.Text:
                return props.value;
            case FormViewItemEnum.TextArea:
                return <pre style={{margin:0}}>{props.value}</pre>;
            case FormViewItemEnum.Editor:
                return <FroalaEditorView model={props.value} />
            case FormViewItemEnum.Image:
                return  <>
                            <div className="_imgs">
                                {typeof(props.value)=="object" && props.value.map(
                                    (v:any,k:any)=><FormImage onView={()=>PreviewApi.preview(k,flatMediaArray(props.value))} key={k} value={v} thumbHeight={150}/>
                                )}
                            </div>
                            {/* {typeof(props.value)=="object" && props.value.map(
                                (v: any,k: any)=><Image imgProps={{height: "280px",width:'auto'}} width="auto" objectFit="cover" height={280} group="frm-imgs" key={k} src={v.file} style={{marginLeft:10}}/>
                            )} */}
                        </>
            case FormViewItemEnum.Url:
                return <a href={props.value} target="_blank">{props.value}</a>
            case FormViewItemEnum.Email:
                return <a href={"mailto:"+props.value}>{props.value}</a>
            case FormViewItemEnum.CheckBox:
                return <i className={`${props.value ? "icon-icons8-checked _true" : "icon-icons8-cancel _false"}`}/>
            default:
                return props.value
        }
    }
    return(
        <div className={props.className}>
            {props.label &&
                <label>
                    {props.label + ":"}
                </label>
            }
            <div className="_val">
                {getCmp()}
            </div>
        </div>
    )
}
const FormViewItem = styled(FormViewItemComponent)(props=> `
    &:last-child {
        border-bottom: 0;
    }
    width: 100%;

    display: flex;
    flex-direction: ${props.type != FormViewItemEnum.TextArea && props.type != FormViewItemEnum.Image ? "row" : "column"};
    justify-content: ${props.type == FormViewItemEnum.Email || props.type == FormViewItemEnum.CheckBox || props.type == FormViewItemEnum.Url ||  props.type == FormViewItemEnum.Number ? "space-between" : "flex-start"};

    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 18px;
    padding-right: 18px;

    border-bottom: 1px solid rgba(63,63,68,.07);
    box-sizing: border-box;
    * {
        box-sizing: border-box;
    }
    label {
        padding-left: 7px;
        font-family: ${CONSTS.fonts.primary.light};
        font-weight: 300;
        font-size: 14px;
        color: ${CONSTS.colors.greyDarker}};
        width: ${props.type != FormViewItemEnum.TextArea && props.type != FormViewItemEnum.Image ? "auto" : "100%"};
    }
    ._val {
        box-sizing: border-box;
        line-height: ${props.type != FormViewItemEnum.TextArea ? "auto" : "26px"};
        padding-top: ${props.type != FormViewItemEnum.TextArea && props.type != FormViewItemEnum.Image ? "0" : "8px"};
        padding-bottom: ${props.type == FormViewItemEnum.TextArea || props.type == FormViewItemEnum.Image ? "4px" : "0"};
        font-family: ${CONSTS.fonts.primary.regular};
        font-size: 14px;
        color: ${CONSTS.colors.primaryDark}};
        width: ${props.type != FormViewItemEnum.TextArea && props.type != FormViewItemEnum.Image ? "auto" : "100%"};
        i {
            font-size: 23px;
            line-height: 0px !important;
            &:before {
                line-height: 0px !important;
                top:5px;
            }
        }
        ._true {
            color: ${CONSTS.colors.success};
        }
        ._false {
            color: ${CONSTS.colors.error};
        }
        * {
            font-family: ${CONSTS.fonts.primary.regular};
        }
    }
`)
export default FormViewItem;